/* New Nubian Fashions: interactions for nnf-* sections (vanilla, no dependencies) */
(function () {
  function money(cents, fmt) {
    var v = (cents / 100);
    var s = v % 1 ? v.toFixed(2) : String(Math.round(v));
    if (!fmt) return '$' + s;
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, s);
  }

  function init(root) {
    root = root || document;

    /* product grid filters */
    root.querySelectorAll('.nnf-filters').forEach(function (bar) {
      if (bar.dataset.bound) return; bar.dataset.bound = '1';
      var grid = bar.closest('section').querySelector('[data-grid]');
      bar.addEventListener('click', function (e) {
        var b = e.target.closest('[data-filter]'); if (!b) return;
        bar.querySelectorAll('[data-filter]').forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-selected', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-selected', 'true');
        var f = b.dataset.filter;
        grid.querySelectorAll('.nnf-card').forEach(function (c) {
          var tags = (c.dataset.tags || '').split(/\s+/);
          c.classList.toggle('hide', f !== 'all' && tags.indexOf(f) === -1);
        });
      });
    });

    /* family set builder: real variants, real cart */
    root.querySelectorAll('[data-nnf-builder]').forEach(function (sec) {
      if (sec.dataset.bound) return; sec.dataset.bound = '1';
      var min = +sec.dataset.min || 3, pct = +sec.dataset.pct || 15, code = sec.dataset.code || '', fmt = sec.dataset.money;
      var chips = sec.querySelectorAll('[data-member]');
      function sel() { return [].filter.call(chips, function (c) { return c.getAttribute('aria-pressed') === 'true'; }); }
      function priceOf(c) {
        var s = sec.querySelector('[data-size="' + c.dataset.member + '"]');
        var o = s && s.options[s.selectedIndex];
        return o ? +o.dataset.price : +c.dataset.price;
      }
      function upd() {
        var list = sel(), n = list.length, sum = list.reduce(function (a, c) { return a + priceOf(c); }, 0), ok = n >= min;
        var saved = Math.round(sum * pct / 100);
        sec.querySelector('[data-b-count]').textContent = n + (n === 1 ? ' piece' : ' pieces');
        sec.querySelector('[data-b-was]').textContent = ok ? money(sum, fmt) : '';
        sec.querySelector('[data-b-now]').textContent = money(ok ? sum - saved : sum, fmt);
        sec.querySelector('[data-b-meter]').style.width = Math.min(n / min, 1) * 100 + '%';
        var h = sec.querySelector('[data-b-hint]');
        h.textContent = ok ? 'Family set unlocked: you save ' + money(saved, fmt) + (code ? ' with ' + code : '')
          : n === 0 ? 'Choose your family members' : 'Add ' + (min - n) + ' more to unlock ' + pct + '% off';
        h.classList.toggle('win', ok);
        chips.forEach(function (c) {
          var fig = sec.querySelector('[data-fig="' + c.dataset.member + '"]');
          if (fig) fig.classList.toggle('on', c.getAttribute('aria-pressed') === 'true');
        });
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () { c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); upd(); });
      });
      sec.querySelectorAll('[data-size]').forEach(function (s) { s.addEventListener('change', upd); });
      var btn = sec.querySelector('[data-b-add]'), err = sec.querySelector('[data-b-err]');
      btn.addEventListener('click', function () {
        var list = sel();
        if (!list.length) { err.hidden = false; err.textContent = 'Choose at least one family member.'; return; }
        var items = list.map(function (c) { return { id: +sec.querySelector('[data-size="' + c.dataset.member + '"]').value, quantity: 1 }; });
        btn.disabled = true; err.hidden = true;
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('nnf:set-added', { detail: { items: items } }));
            var dest = root + 'cart';
            if (code && list.length >= min) dest = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest);
            window.location.href = dest;
          })
          .catch(function (e) { btn.disabled = false; err.hidden = false; err.textContent = (e && (e.description || e.message)) || 'Something went wrong. Please try again.'; });
      });
      upd();
    });

    /* symbolism tabs */
    root.querySelectorAll('[data-nnf-symbols]').forEach(function (sec) {
      if (sec.dataset.bound) return; sec.dataset.bound = '1';
      var tabs = sec.querySelectorAll('[data-sym]'), panels = sec.querySelectorAll('.nnf-symbols__panels article');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
          t.setAttribute('aria-selected', 'true');
          panels.forEach(function (p, i) { p.classList.toggle('on', i === +t.dataset.sym); });
        });
      });
    });

    /* reveal on scroll */
    var els = root.querySelectorAll('.nnf-s .reveal:not(.in)');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(el); });
    } else { els.forEach(function (el) { el.classList.add('in'); }); }
  }

  /* scroll effects: hero zoom, TOT parallax, closer fill */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function onScroll() {
    var y = window.scrollY, vh = window.innerHeight;
    document.querySelectorAll('[data-closer]').forEach(function (w) {
      if (reduce) { w.style.setProperty('--fill', '100%'); return; }
      var r = w.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (vh - r.top) / (vh * 0.75)));
      w.style.setProperty('--fill', (p * 100).toFixed(1) + '%');
    });
    if (reduce) return;
    var hero = document.querySelector('.nnf-hero__media img');
    if (hero && y < vh * 1.2) hero.style.transform = 'scale(' + (1.06 + y / vh * 0.08) + ') translateY(' + (y * 0.18) + 'px)';
    document.querySelectorAll('[data-parallax]').forEach(function (bg) {
      var r = bg.parentNode.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh) bg.style.transform = 'translateY(' + ((r.top + r.height / 2 - vh / 2) * -0.12) + 'px)';
    });
  }

  function boot() { init(document); onScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('scroll', onScroll, { passive: true });
  /* Theme Editor: re-init when sections are added or edited */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); onScroll(); });
})();
